// Tags permitidas para uso em templates de e-mail que 
// serão substituídas pelos valores correspondentes durante o envio do e-mail
export const tagsPermitidasAPI = [
    {
        tag: 'NomeUnidade',
        description: 'Nome da unidade/gerência associada a solicitação',
    },
    {
        tag: 'SiglaUnidade',
        description: 'Sigla da unidade/gerência associada a solicitação',
    },
    {
        tag: 'NomeAuditor',
        description: 'Nome do auditor responsável pela solicitação',
    },
    {
        tag: 'NomeGerente',
        description: 'Nome do gerente responsável pela unidade',
    },
    {
        tag: 'NomeEncarregado',
        description: 'Nome do encarregado responsável pela unidade',
    },
    {
        tag: 'NumeroSolicitacao',
        description: 'Número da solicitação associada ao e-mail',
    },
    {
        tag: 'NomeProcesso',
        description: 'Nome do processo associado a solicitação',
    },
    {
        tag: 'CodigoCompliance',
        description: 'Código do Compliance associado a solicitação',
    },
    {
        tag: 'NomeServico',
        description: 'Nome do Serviço associado a solicitação',
    },
    {
        tag: 'DataRegistro',
        description: 'Data em que a solicitação foi registrada',
    },
    {
        tag: 'DataLimite',
        description: 'Data limite para a solicitação ser respondida',
    },
    {
        tag: 'StatusSolicitacao',
        description: 'Status atual da solicitação',
    },
];
